import { BarChartOutlined, TagsOutlined, UploadOutlined, WalletOutlined } from '@ant-design/icons';

const cajas = {
  id: 'group-cajas',
  title: 'Caja',
  type: 'group',
  children: [
    // Página principal "Desempeño de la ruta" (US-015).
    {
      id: 'panel-principal',
      title: 'Desempeño de la ruta',
      type: 'item',
      url: '/panel-principal',
      icon: BarChartOutlined,
      permission: 'caja.consultar'
    },
    { id: 'cajas', title: 'Caja', type: 'item', url: '/cajas', icon: WalletOutlined, permission: 'caja.consultar' },
    // Sin `permission` a propósito (visible para todos por ahora); ver TODO(US-010) en MainRoutes.
    { id: 'subir-cartera', title: 'Subir cartera', type: 'item', url: '/cartera/subir', icon: UploadOutlined },
    // Catálogo de tipos de movimiento (US-018 crear / US-019 histórico).
    {
      id: 'tipos-movimiento',
      title: 'Tipos de movimiento',
      type: 'item',
      url: '/tipos-movimiento',
      icon: TagsOutlined,
      permission: 'tipos-movimiento.read'
    }
  ]
};

export default cajas;
